import { TPartialVersionedResource } from "app/queryProvider/interfaces";

export const coreVersionedResource: TPartialVersionedResource<"televisits" | "questionnaire-results" | "device-status"> = {
  televisits: {
    name: "televisits",
    version: "v1",
    microService: "rpm",
    serializer: null,
  },
  "questionnaire-results": {
    name: "questionnaire-results",
    version: "v1",
    microService: "rpm",
    serializer: null,
  },
  "device-status": {
    name: "device-status",
    version: "v1",
    microService: "rpm",
    serializer: null,
  },
};
